import { createApiInstance, LONG_TIMEOUT_CONFIG } from './config'

// 为APK使用长超时配置（适合大文件上传）
const apkAPI = createApiInstance(LONG_TIMEOUT_CONFIG)

// 使用统一的响应拦截器，已在config.js中配置

export default {
  // 公共接口
  
  // 获取最新APK版本
  getLatestAPK(game = 'default') {
    return apkAPI.get('/apk/latest', { params: { game } })
  },

  // 获取软件下载链接
  getSoftwareDownloads() {
    return apkAPI.get('/apk/software/downloads')
  },

  // 管理员接口

  // 上传APK（支持真实上传进度）
  uploadAPK(formData, onUploadProgress) {
    return apkAPI.post('/admin/apk/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      timeout: 600000, // 单独为上传设置10分钟超时
      onUploadProgress: onUploadProgress // 上传进度回调
    })
  },

  // 获取APK列表
  getAPKList(params = {}) {
    const defaultParams = {
      page: 1,
      page_size: 10
    }
    return apkAPI.get('/admin/apk/list', { 
      params: { ...defaultParams, ...params } 
    })
  },

  // 获取单个APK信息
  getAPK(id) {
    return apkAPI.get(`/admin/apk/${id}`)
  },

  // 更新APK信息
  updateAPK(id, data) {
    return apkAPI.put(`/admin/apk/${id}`, data)
  },

  // 删除APK
  deleteAPK(id) {
    return apkAPI.delete(`/admin/apk/${id}`)
  },

  // 切换APK状态
  toggleAPKStatus(id) {
    return apkAPI.post(`/admin/apk/${id}/toggle`)
  },

  // 获取上传进度
  getUploadProgress(taskId) {
    return apkAPI.get(`/admin/apk/upload/progress/${taskId}`)
  },

  // 开始分块上传
  startUpload(fileName, game, totalSize) {
    const formData = new FormData()
    formData.append('fileName', fileName)
    formData.append('game', game)
    formData.append('totalSize', totalSize)
    
    return apkAPI.post('/admin/upload/start', formData)
  },

  // 上传分块
  uploadChunk(uploadId, chunkIndex, totalChunks, chunkFile) {
    const formData = new FormData()
    formData.append('uploadId', uploadId)
    formData.append('chunkIndex', chunkIndex)
    formData.append('totalChunks', totalChunks)
    formData.append('file', chunkFile)
    
    return apkAPI.post('/admin/upload/chunk', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      timeout: 60000 // 1分钟超时
    })
  },

  // 完成上传
  completeUpload(uploadId, name, game, versionCode, description, fileName, totalSize, totalChunks) {
    const formData = new FormData()
    formData.append('uploadId', uploadId)
    formData.append('name', name)
    formData.append('game', game)
    formData.append('version_code', versionCode)
    formData.append('description', description || '')
    formData.append('fileName', fileName)
    formData.append('totalSize', totalSize)
    formData.append('totalChunks', totalChunks)
    
    return apkAPI.post('/admin/upload/complete', formData)
  },

  // 查询分块上传进度
  getChunkUploadProgress(uploadId) {
    return apkAPI.get(`/admin/upload/progress/${uploadId}`)
  }
}